import Dispensed from "../../../component/Pmc/Dispensed/Dispensed"

const PmsDispensed = () => {
  return (
    <>
      <Dispensed />
    </>
  )
}

export default PmsDispensed